import { NavBar } from 'components/NavBar/NavBar'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Flex,
  TabsContainer,
  Tabs,
  H1WithBack,
  PageWrapper,
  ContentWrapper,
} from 'styling/GlobalStyles'
import { InfoRolesTab } from 'pages/ResourcesAdmin/Roles/InfoRolesTab'
import { useNavigate, useParams } from 'react-router-dom'
import { AppDispatch, RootState } from 'store'
import { IRole } from 'types/roles.interface'
import { toast } from 'react-toastify'
import { PermissionsRolesTab } from 'pages/ResourcesAdmin/Roles/PermissionsRolesTab'
import { clearRoleTemplate, getSingleRoleTemplate, updateRoleTemplate } from 'features/roles/roleTemplatesSlice'

export const EditRoleTemplate = () => {
  const [active, setActive] = useState('Info')
  const { singleRoleTemplate } = useSelector((store: RootState) => store.roleTemplates)
  const dispatch = useDispatch<AppDispatch>()
  const navigate = useNavigate()
  const { id } = useParams()

  const [state, setState] = useState<Pick<IRole, 'name' | 'id' | 'permissions'>>({
    name: '',
    id: parseInt(id),
    permissions: {
      dashboard: false,
      aimVision: false,
      hr: false,
      fuel: false,
      machinery: false,
      inventory: false,
      analytics: false,
      resources: false,
      contractors: false
    }
  })

  useEffect(() => {
    dispatch(getSingleRoleTemplate(id))
    return () => {
      dispatch(clearRoleTemplate())
    }
  }, [])

  useEffect(() => {
    if (singleRoleTemplate) {
      setState(singleRoleTemplate)
    }
  }, [singleRoleTemplate])

  const handleSubmit = async () => {
    if (state.name.length < 1) {
      toast.warn('Role template name must be filled')
      return
    }

    const resp = await dispatch(updateRoleTemplate(state))
    if (resp.meta.requestStatus === 'fulfilled') {
      navigate('/resources-role-templates')
    }
  }

  const renderTabs = () => {
    if (active == 'Permissions') {
      return <PermissionsRolesTab state={state} setState={setState} handleSubmit={handleSubmit} />
    }
    return <InfoRolesTab state={state} setState={setState} handleSubmit={handleSubmit} />
  }

  return (
    <div>
      <NavBar />
      <PageWrapper noFooter>
        <Flex between main>
          <H1WithBack mb='1.5' arrow title={'Edit ' + singleRoleTemplate ? singleRoleTemplate.name : ''} />
          <TabsContainer>
            <Tabs active={active === 'Info'} onClick={() => setActive('Info')}>
              Info
            </Tabs>
            <Tabs active={active === 'Permissions'} onClick={() => setActive('Permissions')}>
              Permissions
            </Tabs>
          </TabsContainer>
        </Flex>
        <ContentWrapper>{renderTabs()}</ContentWrapper>
      </PageWrapper>
    </div>
  )
}
